import { AuthService } from './../../../core/services/auth.service';
import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPwdForm: FormGroup = new FormGroup({
    emailFormControl:  new FormControl('', [
      Validators.required
    ])
  });
  username: any;
  constructor(private router: Router, private authService: AuthService) {

   }

  ngOnInit() {
  }
  goto() {
    if(this.forgotPwdForm.valid){
      Swal.fire({
        title: 'Processing...'
      });
      Swal.showLoading();
      this.authService.generateOTP(this.forgotPwdForm.controls['emailFormControl'].value).subscribe(
        (registerStatus:any) => {
          Swal.close();
          if(registerStatus.status === 200) {
            Swal.fire('OTP Sent To Your Mail.', '', 'success');
            sessionStorage.setItem('user', this.forgotPwdForm.controls['emailFormControl'].value);
            this.router.navigate([`reset-password`]);
          }
          else {
            Swal.fire('',registerStatus.message ? registerStatus.message : 'Something went wrong! please try again later','error');
          }
          // swal.close();
          // swal('OTP Sent To Your Mail.', '', 'success');
          // sessionStorage.setItem('user', this.username);
          // this.router.navigate([`resetPwd`]);
        },
        error => {
          Swal.close();
          Swal.fire('', error ? error : 'Something went wrong! please try again later' , 'error');
        }
      );
    }
    else {
      Swal.close();
      Swal.fire('', 'Please enter all the required field', 'error');
    }
  }

}
